export let EventType = /*#__PURE__*/function (EventType) {
  EventType["AUTH_STATE_LOADED"] = "AUTH_STATE_LOADED";
  EventType["READY_GET_AUTH_STATE"] = "READY_GET_AUTH_STATE";
  EventType["PREFERENCES_LOADED"] = "PREFERENCES_LOADED";
  EventType["READY_GET_PREFERENCES"] = "READY_GET_PREFERENCES";
  EventType["LOGIN_METHODS_LOADED"] = "LOGIN_METHODS_LOADED";
  EventType["READY_GET_LOGIN_METHODS"] = "READY_GET_LOGIN_METHODS";
  EventType["THEME_LOADED"] = "THEME_LOADED";
  EventType["READY_GET_THEME"] = "READY_GET_THEME";
  return EventType;
}({});